import React from 'react'
import TimeSlot from './TimeSlot'

const TimeSlotContainer = ({ slots, setSelectedTime }) => {
  return (
    <div className="time-slot-container">
      <div className="time-slot-inner-container">
        { slots.map(slot => <TimeSlot key={slot.id} slot={slot} onClick={setSelectedTime} />) }
      </div>
    </div>
  )
}

export default TimeSlotContainer
